const DEFAULT_INVALID_RANGE_MESSAGE =
  "종료일은 시작일보다 이전일 수 없습니다.";

const normalizeDateValue = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const normalizedValue =
    typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
      ? `${value}T00:00:00`
      : value;

  const date = new Date(normalizedValue);
  return Number.isNaN(date.getTime()) ? null : date;
};

export function validateDateRange(startDate, endDate, options = {}) {
  const message = options.message || DEFAULT_INVALID_RANGE_MESSAGE;
  const normalizedStartDate = normalizeDateValue(startDate);
  const normalizedEndDate = normalizeDateValue(endDate);

  if (!normalizedStartDate || !normalizedEndDate) {
    return {
      isValid: true,
      message: "",
    };
  }

  if (normalizedEndDate < normalizedStartDate) {
    return {
      isValid: false,
      message,
    };
  }

  return {
    isValid: true,
    message: "",
  };
}

export { DEFAULT_INVALID_RANGE_MESSAGE };
